import React from 'react';
export const SlovHeader = () =>
{
    return(<h1 id = "slov_header">ОТКРЫТОЧНАЯ (CYBERBOX)</h1>);
} 